import React from "react";

export default function Thumb(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.8" height="12.545" viewBox="0 0 13.8 12.545">
			<path
				id="ic_thumb_up_24px"
				d="M1,13.545H3.509V6.018H1Zm13.8-6.9a1.258,1.258,0,0,0-1.255-1.255H9.587l.6-2.867.019-.2a.944.944,0,0,0-.276-.665L9.261,1,5.134,5.134a1.226,1.226,0,0,0-.37.884v6.273a1.258,1.258,0,0,0,1.255,1.255h5.645a1.246,1.246,0,0,0,1.154-.765l1.894-4.422A1.239,1.239,0,0,0,14.8,7.9V6.7L14.794,6.7Z"
				transform="translate(-1 -1)"
				fill="#32a8a4"
			/>
		</svg>
	);
}

export function ThumbLg() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="70" height="64">
			<path
				d="M0 64h12.727V25.6H0Zm70-35.2a6.4 6.4 0 0 0-6.364-6.4H43.559l3.023-14.624.1-1.024a4.831 4.831 0 0 0-1.4-3.392L41.9 0 20.968 21.088a6.275 6.275 0 0 0-1.877 4.512v32a6.4 6.4 0 0 0 6.364 6.4h28.636a6.32 6.32 0 0 0 5.855-3.9l9.609-22.56A6.354 6.354 0 0 0 70 35.2v-6.112l-.032-.032Z"
				fill="#32a8a4"
			/>
		</svg>
	);
}
